const canvas = document.createElement('canvas');
const context = canvas.getContext('2d')!;

export function measureTextWidth(text: string, font = '16px Arial') {
  context.font = font;
  const metrics = context.measureText(text);
  return metrics.width;
}
